if (!customElements.get('smaxup-portrait-carousel')) {
  customElements.define('smaxup-portrait-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-smaxup-portrait-viewport]');
      this.track = this.querySelector('[data-smaxup-portrait-track]');
      if (!this.viewport || !this.track) return;
      this.abort = new AbortController();
      const on = (el, type, fn, extra = {}) => el?.addEventListener(type, fn, { signal: this.abort.signal, ...extra });
      this.cards = [...this.track.children].filter(card => !card.hasAttribute('data-loop-copy'));
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.offset = 0; this.last = null; this.visible = true; this.hover = false; this.focused = false; this.paused = false; this.pointer = null; this.tween = null;
      on(this.viewport, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this.viewport, 'pointerover', event => {
        if (this.dataset.pauseHover === 'true' && event.target.closest('[data-smaxup-portrait-card]')) this.hover = true;
      });
      on(this.viewport, 'pointerout', event => {
        if (!event.target.closest('[data-smaxup-portrait-card]')) return;
        const nextCard = event.relatedTarget instanceof Element ? event.relatedTarget.closest('[data-smaxup-portrait-card]') : null;
        this.hover = this.dataset.pauseHover === 'true' && Boolean(nextCard && this.viewport.contains(nextCard));
      });
      on(this.viewport, 'pointerleave', () => { this.hover = false; });
      on(this, 'focusin', () => { this.focused = true; });
      on(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); });
      on(this.viewport, 'pointerdown', event => { this.pointer = event.clientX; this.tween = null; });
      on(this.viewport, 'pointerup', event => {
        if (this.pointer !== null && this.pointer !== undefined && Math.abs(event.clientX - this.pointer) > 35) this.move(event.clientX < this.pointer ? 1 : -1);
        this.pointer = null;
      });
      on(this.viewport, 'pointercancel', () => { this.pointer = null; });
      on(this.viewport, 'dragstart', event => event.preventDefault());
      on(document, 'shopify:block:select', event => {
        const card = event.target.closest('[data-smaxup-portrait-card]');
        const index = this.cards.indexOf(card);
        if (index < 0) return;
        this.paused = true; this.tween = null; this.offset = index * this.step; this.render();
      });
      this.resize = new ResizeObserver(() => this.measure()); this.resize.observe(this.viewport);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }); this.intersection.observe(this);
      this.measure();
      const frame = now => {
        const elapsed = this.last === null ? 0 : Math.min(50, now - this.last); this.last = now;
        if (this.tween) {
          const p = Math.min(1, (now - this.tween.start) / 500);
          this.offset = this.tween.from + this.tween.distance * (1 - Math.pow(1 - p, 3));
          if (p === 1) this.tween = null;
        } else if (this.dataset.autoplay === 'true' && this.cards.length > 1 && this.visible && !this.hover && !this.focused && this.pointer == null && !this.paused && !this.reduce.matches && !document.hidden && !window.Shopify?.designMode) {
          this.offset += elapsed * (Number(this.dataset.speed) || 25) / 1000;
        }
        this.render(); this.frame = requestAnimationFrame(frame);
      };
      this.frame = requestAnimationFrame(frame);
    }
    measure() {
      this.track.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
      this.step = (this.cards[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(this.track).gap) || 0);
      this.period = this.cards.length * this.step;
      if (!this.period || this.cards.length < 2) { this.offset = 0; this.render(); return; }
      const copies = Math.ceil(this.viewport.clientWidth / this.period) + 1;
      for (let i = 0; i < copies; i++) for (const card of this.cards) {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-loop-copy', ''); clone.setAttribute('aria-hidden', 'true'); clone.inert = true;
        [clone, ...clone.querySelectorAll('*')].forEach(el => {
          [...el.attributes].forEach(attr => { if (attr.name === 'id' || attr.name.startsWith('data-shopify-')) el.removeAttribute(attr.name); });
        });
        this.track.appendChild(clone);
      }
      this.render();
    }
    render() {
      const position = this.period ? ((this.offset % this.period) + this.period) % this.period : 0;
      this.track.style.transform = 'translate3d(' + (-position) + 'px,0,0)';
    }
    move(direction) {
      if (this.cards.length < 2 || !this.step) return;
      this.tween = null;
      if (this.reduce.matches) { this.offset += direction * this.step; this.render(); }
      else this.tween = { from: this.offset, distance: direction * this.step, start: performance.now() };
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect(); cancelAnimationFrame(this.frame);
      this.track?.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
    }
  });
}
